import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { PHOTREAM_APP } from "../../config";
import { IUser } from "../../interfaces";
import axios from "../../modules/axiosInstance";
import Button from "../atoms/Button";
import UserNameAndStatus from "../molecules/UserNameAndStatus";

interface IProps {
  user: IUser | null;
  changeCorrespondenceStatus: () => void;
}

const MessageHeader: React.FC<IProps> = ({
  user,
  changeCorrespondenceStatus
}) => {
  const goPhotreamAdmin = () => {
    if (user) {
      const url = `${PHOTREAM_APP}/photream_admin/customer/from_line`;
      const params = new FormData();
      params.append("line_identifier", user.lineIdentifier);
      axios
        .post(url, params)
        .then(result => {
          console.log(result);
          const userId = result.data;
          window.open(
            `${PHOTREAM_APP}/photream_admin/customers/${userId}`,
            "_blank"
          );
        })
        .catch(error => console.log(error));
    }
  };
  return (
    <OutWrapper>
      <BackButton>
        <Link to="/talks">
          <i className="far fa-angle-left" />
        </Link>
      </BackButton>
      <UserName>
        <UserNameAndStatus user={user} />
      </UserName>
      <StatusChangeButtonWrapper>
        <StatusChangeButton
          title="ステータス変更"
          onClick={changeCorrespondenceStatus}
        />
        <Button title="ユーザー詳細へ(comへ遷移)" onClick={goPhotreamAdmin} />
      </StatusChangeButtonWrapper>
    </OutWrapper>
  );
};

const OutWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ddd;
  padding: 20px 0px 16px;
  height: 52px;
  z-index: 10;
`;

const BackButton = styled.div`
  position: absolute;
  left: 16px;
`;

const UserName = styled.h2`
  text-align: center;
  margin: 0;
  font-size: 1rem;
`;

const StatusChangeButtonWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 16px;
`;

const StatusChangeButton = styled(Button)``;

export default MessageHeader;
